<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
    <div class="form-horizontal">
      <div class="row">
        <div class="col-md-12">
            <div class="form-group row">              
                <label class="col-form-label col-2"><span translate="PODVRSTADOKUMENTA.AKTIVAN.SINGULAR"></span></label>
                <div class="col-md-1">
                    <input
                      style="width: 20px;"
                      type="checkbox"
                      name="chkAktivan"
                      class="form-control"
                      formControlName="IsActive"
                      >
                  </div>
              </div>

            <div class="form-group row">
                <div class="col-md-12">
                    <!-- <yt-fw-dropdown
                    [ModelName]="'vrstadokumenta'"
                    [GetName]="'get'"
                    [ModelProperty]="'Naziv'"
                    [OrderBy]="'Naziv'"
                    [AllowAddNew]='false'
                    formControlName="VrstaDokumentaID"
                    name="cmbVrstaDokumenta"
                    [Type]="ID"
                    [ngClass]="{'is-invalid': submitted && fc.VrstaDokumentaID.invalid}"
                    [Label]="'VRSTADOKUMENTA.SINGULAR'">
                  </yt-fw-dropdown> -->
                  <yt-dropdown-picklist
                    [ModelName]="'vrstadokumenta'"
                    [GetName]="'get'"
                    [ModelProperty]="'Naziv'"
                    [OrderBy]="'Naziv'"
                    [AllowAddNew]="false"
                    [AllowEdit]="true"
                    formControlName="VrstaDokumentaID"
                    [Label]="'VRSTADOKUMENTA.SINGULAR'"
                  >
                  </yt-dropdown-picklist>
                  <div class="form-error" *ngIf="submitted && fc.VrstaDokumentaID.invalid">
                      <span *ngFor="let validation of errorMessages.VrstaDokumentaID">
                        <span class="error-message" *ngIf="fc.VrstaDokumentaID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                      </span>
                  </div>
                </div>
             </div>
          <div class="form-group row">
              <!-- <label class="col-form-label col-2"><span translate="PODVRSTADOKUMENTA.NAZIV.SINGULAR"></span></label> -->
              <div class="col-md-12">
                <yt-input
                  [Type]="'text'"
                  name="txtNaziv"              
                  #focusElement
                  [MaxLength]="100"   
                  formControlName="Naziv"                          
                  [ngClass]="{'is-invalid': submitted && fc.Naziv.invalid}"
                  [Label]="'PODVRSTADOKUMENTA.NAZIV.SINGULAR'">
                </yt-input>
                  <div class="form-error" *ngIf="submitted && fc.Naziv.invalid">
                    <span *ngFor="let validation of errorMessages.Naziv">
                      <span class="error-message" *ngIf="fc.Naziv.hasError(validation.type)">
                        <span translate="{{validation.message}}"></span>
                      </span>
                    </span>
                  </div>
              </div>
            </div>
          <div class="form-group row">
            <!-- <label class="col-form-label col-2"><span translate="PODVRSTADOKUMENTA.SNAZIV.SINGULAR"></span></label> -->
            <div class="col-md-12">
              <yt-input
                [Type]="'text'"
                name="txtSnaziv"
                [MaxLength]="10"
                formControlName="SNaziv" 
                [ngClass]="{'is-invalid': submitted && fc.SNaziv.invalid}"
                [Label]="'PODVRSTADOKUMENTA.SNAZIV.SINGULAR'">
              </yt-input>
                <div class="form-error" *ngIf="submitted && fc.SNaziv.invalid">
                  <span *ngFor="let validation of errorMessages.SNaziv">
                    <span class="error-message" *ngIf="fc.SNaziv.hasError(validation.type)">
                      <span translate="{{validation.message}}"></span>
                    </span>
                  </span>
                </div>                
            </div>
          </div>
          <div class="form-group row">
            <!-- <label class="col-form-label col-2"><span translate="PODVRSTADOKUMENTA.GENERICNAME.SINGULAR"></span></label> -->
            <div class="col-md-12">
              <yt-input
                [Type]="'text'"
                name="txtGenNaziv"
                [MaxLength]="10"
                formControlName="GenericName" 
                [ngClass]="{'is-invalid': submitted && fc.GenericName.invalid}"
                [Label]="'PODVRSTADOKUMENTA.GENERICNAME.SINGULAR'">
              </yt-input>
                <div class="form-error" *ngIf="submitted && fc.GenericName.invalid">
                  <span *ngFor="let validation of errorMessages.GenericName">
                    <span class="error-message" *ngIf="fc.GenericName.hasError(validation.type)">
                      <span translate="{{validation.message}}"></span>
                    </span>
                  </span>
                </div>                
            </div>
          </div>
          <div class="form-group row">
            <!-- <label class="col-form-label col-2"><span translate="PODVRSTADOKUMENTA.GENERICNAME.SINGULAR"></span></label> -->
            <div class="col-md-12">
              <yt-input
                [Type]="'text'"
                name="txtModel"
                [MaxLength]="50"
                formControlName="Model" 
                [ngClass]="{'is-invalid': submitted && fc.Model.invalid}"
                [Label]="'PODVRSTADOKUMENTA.MODEL.SINGULAR'">
              </yt-input>
                <div class="form-error" *ngIf="submitted && fc.Model.invalid">
                  <span *ngFor="let validation of errorMessages.Model">
                    <span class="error-message" *ngIf="fc.Model.hasError(validation.type)">
                      <span translate="{{validation.message}}"></span>
                    </span>
                  </span>
                </div>                
            </div>
          </div>
          <div class="form-group row">
            <!-- <label class="col-form-label col-2"><span translate="PODVRSTADOKUMENTA.OZNAKA.SINGULAR"></span></label> -->
            <div class="col-md-12">
              <yt-input
                [Type]="'text'"
                name="txtOpis"
                [MaxLength]="200"
                formControlName="Opis" 
                [ngClass]="{'is-invalid': submitted && fc.Opis.invalid}"
                [Label]="'PODVRSTADOKUMENTA.OPIS.SINGULAR'">
              </yt-input>
                <div class="form-error" *ngIf="submitted && fc.Opis.invalid">
                  <span *ngFor="let validation of errorMessages.Opis">
                    <span class="error-message" *ngIf="fc.Opis.hasError(validation.type)">
                      <span translate="{{validation.message}}"></span>
                    </span>
                  </span>
                </div>                
            </div>
          </div>
          <div class="form-group row">
            <label class="col-form-label col-2"><span translate="PODVRSTADOKUMENTA.ODGOVORNOLICEJEOBAVEZNO.SINGULAR"></span></label>
            <div class="col-md-1">
              <input
                style="width: 20px;"
                type="checkbox"
                name="chkOdgovoroLiceJeObavezno"
                class="form-control"
                formControlName="OdgovornoLiceJeObavezno"
                autocomplete="off"
                >
            </div>
          </div>
          <!-- <div class="form-group row">
            <label class="col-form-label col-2"><span translate="PODVRSTADOKUMENTA.VRSTADOKUMENTAID.SINGULAR"></span></label>
            <div class="col-md-10">
                <yt-fw-dropdown
                [ModelName]="'vrstadokumenta'"
                [GetName]="'get'"
                [ModelProperty]="'Naziv'"
                [OrderBy]="'Naziv'"
                [AllowAddNew]='true'
                [Required]='true'
                [Disabled]='false'                
                name="cmbVrstaDokumenta"
                [Type]="ID"
                >
              </yt-fw-dropdown>
            </div>
        </div> -->
        <!-- <div class="form-group row">
            <label class="col-form-label col-2"><span>TIp Komitenta</span></label>
            <div class="col-md-10">
              <input
                type="text"
                name="txtTipKomitenta"
                class="form-control"
                [(ngModel)]="Item.PodvrstaDokumentaTipKomitenta"
                autofocus
                required
                maxlength="200"
                #PodvrstaDokumentaTipKomitenta="ngModel">
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </form>